<template>
  <div class="userCenter">
    <div class="headBox">
      <van-row class="firstRow" v-if="userInfo.IsRegister">
        <router-link tag="div" to="">
          <div style="display: flex;padding:0 10px;align-items: center;position: relative">
            <div class="headImg">
              <img v-if="userInfo.Headimgurl" :src="userInfo.Headimgurl" alt="" />
              <svg-icon v-else class-name="zl-icon iconfont" icon-class="default-head" style="font-size: 70px;"></svg-icon>
            </div>
            <div class="info">
              <div class="info_name">{{ userInfo.Name }}</div>
              <div class="info_regionname">{{ userInfo.RegionName }}</div>
              <div class="info_address" @click.stop="linkTo('/userIn/userChangeRoom')">
                {{ userInfo.FullAddress }}
                <span class="iconfont iconxiangyou1"></span>
              </div>
            </div>
            <div style="position: absolute;right: 20px;top: 4px;" @click.stop="linkTo('/userIn/userInfo')"><svg-icon icon-class="个人信息" style="font-size: 26px;"></svg-icon></div>
          </div>
        </router-link>
      </van-row>
      <div v-else class="IsRegister">
        <router-link to="/bindingMobile"> <svg-icon class-name="zl-icon iconfont" icon-class="bind" style="font-size: 16px;"></svg-icon> 绑定 </router-link>
      </div>
      <div class="refundCss_div">
        <div class="refundCss" @click="linkTo('/userIn/balanceUseDetail')">
          <svg-icon class-name="zl-icon iconfont" icon-class="wallet" color="#fff" style="font-size: 50px;"></svg-icon>
          <div class="money">
            <div class="second"><span>余额</span>&nbsp;&nbsp;￥{{ userInfo.Balance }}</div>
            <!--            <div class="first">余额</div>-->
            <div class="other">押金余额&nbsp;&nbsp;&nbsp;￥{{ userInfo.BalanceDeposit }}&nbsp;&nbsp;&nbsp;&nbsp;租金余额&nbsp;&nbsp;&nbsp;￥{{ userInfo.BalancePrice }}</div>
          </div>
          <!--          -->
          <div v-if="userInfo.Balance > 0 && userInfo.IsReturn" class="Button-out">
            <div @click.stop="refund" class="refundButton">退款</div>
          </div>
        </div>
      </div>
    </div>

    <div class="cellBox">
      <van-cell-group>
        <div @click="goTo('租赁信息')">
          <van-cell is-link to="user">
            <template slot="title">
              <i class="iconfont icondingdan"></i>
              <span> 租赁信息</span>
            </template>
          </van-cell>
        </div>
        <div @click="goTo('报修信息')">
          <van-cell is-link to="user">
            <template slot="title">
              <svg-icon icon-class="报修2" class="iconfont special" color="#07c160"></svg-icon>
              <span> 报修信息</span>
            </template>
          </van-cell>
        </div>
        <div @click="goTo('退租信息')">
          <van-cell is-link to="user">
            <template slot="title">
              <svg-icon icon-class="退租2" class="iconfont" color="#07c160"></svg-icon>
              <span> 退租信息</span>
            </template>
          </van-cell>
        </div>
        <router-link :to="{path: userInfo.IsRegister?'/equipment/orderMain': '/bindingMobile', query: {type: '换寝', title: '换寝申请', backUrl: 'user'}}" replace>
          <van-cell is-link to="user">
            <template slot="title">
              <svg-icon icon-class="applyForList" class="iconfont" color="#07c160"></svg-icon>
              <span> 换寝申请</span>
            </template>
          </van-cell>
        </router-link>
        <a href="https://b.eqxiu.com/s/ZvTyIAar">
          <van-cell is-link to="user">
            <template slot="title">
              <i class="iconfont iconliuyan"></i>
              <span> 关于我们</span>
            </template>
          </van-cell>
        </a>
        <router-link :to="{path: '/userIn/help', query: { backUrl: 'user' }}" replace>
          <van-cell is-link to="user">
            <template slot="title">
              <i class="iconfont iconwenhao"></i>
              <span> 帮助说明</span>
            </template>
          </van-cell>
        </router-link>
        <router-link
            :to="{
            path: '/userIn/article',
            query: { Id: '9584f824-3b3c-45cb-bd44-89764c479ca0', backUrl: 'user' },
          }"
            replace
        >
          <van-cell is-link to="user">
            <template slot="title">
              <i class="iconfont iconwenhao"></i>
              <span> 协议条款</span>
            </template>
          </van-cell>
        </router-link>
      </van-cell-group>
    </div>
    <van-popup v-model="refundVisible" style="width: 90%" closeable>
      <div
          class="van-ellipsis van-picker__title"
          style="
          margin-top: 15px;
          font-size: 0.373333rem;
          margin-bottom: 15px;
          min-width: 100%;
        "
      >
        退款
      </div>
      <van-field
          :value="userInfo.BalanceDeposit"
          readonly
          label="押金余额："
          label-width="90"
      />
      <van-field
          :value="userInfo.BalancePrice"
          readonly
          label="租金余额："
          label-width="90"
      />
      <van-field
          v-model="refundModel.Deposit"
          label="退款押金"
          label-width="90"
          placeholder="请输入退款押金"
          required
          clearable
          :error-message="errorMessageDeposit"
          @input="replaceMoney('Deposit')"
      />
      <van-field
          v-model="refundModel.Price"
          label="退款租金"
          label-width="90"
          placeholder="请输入退款租金"
          required
          clearable
          :error-message="errorMessagePrice"
          @input="replaceMoney('Price')"
      />
      <van-field
          v-model="refundModel.BankNumber"
          label="银行卡号"
          label-width="90"
          placeholder="请输入银行卡号"
          required
          clearable
          :error-message="errorMessage2"
          @input="replaceNumber('BankNumber')"
      />
      <van-field
          readonly
          title="开户银行"
          is-link
          required
          :value="refundModel.Bank"
          @click="showBankList = true"
          :error-message="errorMessage4"
          label="开户银行"
      >
      </van-field>
      <van-field
          v-model="refundModel.Result"
          label="退款原因"
          label-width="90"
          placeholder="请输入退款原因"
          required
          clearable
          :error-message="errorMessage3"
          type="textarea"
          :rows="4"
      />
      <div class="footer-btn">
        <span>
          <van-button size="small" @click="refundVisible = false">取消</van-button>
          <van-button size="small" type="primary" @click="rule">提交</van-button>
        </span>
      </div>
    </van-popup>
    <van-popup v-model="showBankList" get-container="body" position="bottom">
      <van-picker
          :columns="bankList"
          show-toolbar
          title="开户银行"
          @cancel="showBankList = !showBankList"
          @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
import {getWeixInfo, setWeixInfo} from "@/utils/auth";
import {removeCookie} from "@/utils/cookie";
export default {
  name: "user",
  data() {
    return {
      bankList: [],
      showBankList: false,
      refundVisible: false,
      refundModel: {},
      userInfo: JSON.parse(getWeixInfo()),
      // userInfo: {},
      errorMessage1: "",
      errorMessage2: "",
      errorMessage3: "",
      errorMessage4: "",
      errorMessageDeposit: '',
      errorMessagePrice: '',
      newUserInfo: {}
    };
  },
  components: {},
  methods: {
    async getBank() {
      try{
        const { Data } = await this.$post('/BizMemberDictionary/AllList',{ParetnName: '退租开户银行'})
        this.bankList = Data
        this.bankList.forEach((data) => {
          data.text = data.Name;
        });
        this.$set(this.refundModel,'Bank', Data.length ? Data[0].Name : '')
      } catch(e){

      }
    },
    onConfirm(value){
      this.$set(this.refundModel, 'Bank', value.Value)
      this.showBankList = false;
    },
    async goTo(type){
      await this.getDetailsByKey()
      await this.handlerLink(type)
    },
    handlerLink(type){
      if(this.userInfo.IsRegister) {
        this.$dialog.confirm({
          title: '提示',
          message: `请确认当前所在寝室：${this.userInfo.RegionName}-${this.userInfo.FullAddress}`,
          confirmButtonText: '确认',
          cancelButtonText: '去换寝'
        }).then(() => {
          let linkUrl = {}
          switch (type) {
            case '租赁信息': {
              linkUrl = {path: '/userIn/userOrder', query: {backUrl: 'user'}}
              break;
            }
            case '报修信息': {
              linkUrl = {path: '/equipment/orderMain', query: {type: '报修',title: '报修',backUrl: 'user'}}
              break
            }
            case '退租信息': {
              linkUrl = {path: '/equipment/orderMain', query: {type: '退租',title: '退租',backUrl: 'user'}}
              break
            }
            default: {
              break
            }
          }
          this.$router.replace(linkUrl)
        }).catch(() => {
          this.$router.replace({path: '/userIn/userChangeRoom', query: { backUrl: 'user' }})
        })
      }else {
        this.$router.replace({path: '/bindingMobile', query: {backUrl: 'user'}})
      }
    },
    linkTo(url){
      this.$router.replace({path: url, query: { backUrl: 'user' }})
    },
    replaceMoney(val) {
      this.$set(
          this.refundModel,
          val,
          this.refundModel[val].match(/^\d*(\.?\d{0,2})/g)[0]
      );
      if (this.refundModel.Deposit > this.userInfo.BalanceDeposit) {
        this.refundModel.Deposit = this.userInfo.BalanceDeposit;
      }
      if (this.refundModel.Price > this.userInfo.BalancePrice) {
        this.refundModel.Price = this.userInfo.BalancePrice;
      }
    },
    replaceNumber(val) {
      this.$set(
          this.refundModel,
          val,
          this.refundModel[val].match(/^\d*(\.?\d)/g)[0]
      );
    },
    refund() {
      this.refundModel = {
        Money: this.userInfo.Balance,
        BankNumber: "",
        Result: "",
      };
      this.errorMessage1 = "";
      this.errorMessage2 = "";
      this.errorMessage3 = "";
      this.getBank()
      this.refundVisible = true;
    },
    rule() {
      this.errorMessage1 = ''
      this.errorMessage2 = ''
      this.errorMessage3 = ''
      this.errorMessage4 = ''
      this.errorMessageDeposit = ''
      this.errorMessagePrice = ''
      if (!this.refundModel.Deposit) {
        this.errorMessageDeposit = "请输入退款押金";
        return false
      } else if (!this.refundModel.Price) {
        this.errorMessagePrice = "请输入退款租金";
        return false
      } else if (!this.refundModel.BankNumber) {
        this.errorMessage2 = "请输入银行卡号";
        return false
      } else if(this.refundModel.BankNumber) {
        const regex = /^\d{19}$/
        if(!regex.test(this.refundModel.BankNumber)) {
          this.errorMessage2 = "请输入正确的银行卡号";
          return false;
        } else if (!this.refundModel.Bank) {
          this.errorMessage4 = "请选择开户银行";
          return false;
        } else {
          this.errorMessage2 = "";
        }
        if (!this.refundModel.Result) {
          this.errorMessage3 = "请输入退款原因";
        } else {
          this.errorMessage3 = "";
          this.sub();
        }
      }
    },
    sub() {
      this.$toast.loading({
        duration: 0,
      });
      let url = "/BizMemberMember/BalanceReturn";
      let params = {
        Money: Number(this.refundModel.Deposit) + Number(this.refundModel.Price),
        Deposit: this.refundModel.Deposit,
        Price: this.refundModel.Price,
        Id: this.userInfo.Id,
        BankNumber: this.refundModel.BankNumber,
        RentReason: this.refundModel.Result,
        Bank: this.refundModel.Bank,
      };
      this.$post(url, params).then((res) => {
        if (res.Status === 1) {
          this.errorMessage = "";
          this.refundVisible = !this.refundVisible;
          // this.$refs.trList.onRefresh();
          this.$toast.loading().clear();
          this.$toast(res.Message);
        } else {
          this.errorMessage = "";
          this.show = !this.show;
          // this.$refs.trList.onRefresh();
          this.$toast.loading().clear();
          this.$toast.fail(res.Message);
        }
      });
    },
    async getDetailsByKey() {
      try {
        const res = await this.$post('/BizMemberMember/DetailsByKey')
        if(res.Status === 1) {
          this.$set(this, 'userInfo', res.Data)
          setWeixInfo(JSON.stringify(res.Data))
        }
      }catch (e) {
      }
    },
  },
  mounted() {
    this.getDetailsByKey()
    removeCookie('userAddressCache')
  },
};
</script>

<style lang="less" scoped>
.userCenter {
  .footer-btn {
    width: 100%;
    text-align: right;
    padding: 15px 20px;
    button:nth-child(1) {
      margin-right: 15px;
    }
    button{
      border-radius: 6px;
      width: 50px;
    }
  }
  .refundCss_div{
    padding:15px 15px 0;
  }
  .refundCss {
    position: relative;
    padding: 15px 20px;
    display: flex;
    align-items: center;
    background: linear-gradient(to right, #322f43, #2d6b2d);

    font-size: 12px;
    border-radius: 5px;
    .van-button__content {
      padding: 5px;
    }
    .money{
      flex:1;
      margin-left:15px;
    }
    .first {
      display: block;
      padding: 0 0 0 5px;
      font-size: 14px;
      color:#f2f2f2;
    }
    .second {
      display: block;
      padding: 3px 0;
      font-size: 24px;
      color:#fff;
    }
    .other{
      font-size: 12px;
      color: #eeeeee;
      margin-top: 5px;
    }
    .Button-out {
      position: absolute;
      right: 20px;
      top: 20px;
      background-color: #fff;
      border-radius: 25px;
      .refundButton {
        font-size: 12px;
        padding:5px 20px;
      }
    }
  }
  .headBox {
    width: 100%;
    background: #ffffff;
    padding:20px 0;
    // padding-bottom: 4vh;
    .firstRow {
      .info {
        padding: 0 10px;
        color: #303133;
        flex:1;
        .info_name{
          display: flex;
          font-size:20px;
          align-items: center;
        }
        .info_regionname{
          background: #07c160;
          color:#fff;
          padding:0 5px;
          border-radius: 3px;
          font-size:12px;
          display: inline-block;
          height:20px;
          line-height:20px;
          margin-top:5px;
        }
        .info_address{
          color:#999;
          font-size:14px;
          margin-top:5px;
          span{
            float: right;
            margin-top: 2px;
          }
        }
      }
      .headImg {
        img {
          width: 70px;
          height: 70px;
          border-radius: 50%;
        }

      }
    }
    .sceRow {
      text-align: center;
      color: #999999;
      .cyxx {
        width: 100%;
        line-height: 28px;
        border-right: 1px solid #eee;
      }
      .ddxx {
        width: 100%;
        line-height: 28px;
      }
    }
  }
  .cellBox {
    border-radius: 5px;
    margin-top: 15px;
    >div{
      padding:0 15px;
      box-sizing: border-box;
      display: block;
    }
    .van-cell{
      padding:15px 0;
      background: none;
      border-bottom:1px solid #f8f8f8;
    }
    .van-cell__title{
      display: flex;
      align-items: center;
      span{
        font-size:16px;
      }
    }
    .special{
      font-size: 22px!important;
      margin-left: 3px;
    }
    .iconfont {
      color: #07c160;
      font-size:26px;
      margin-right: 10px;
    }
    .van-cell-group{
      border-radius: 5px;
    }
  }
}
.IsRegister {
  display: flex;
  justify-content: center;
  align-items: center;
  padding:10px;
  color:#2d652e;
  //padding: 6vh 0;
  a {
    -webkit-border-radius: 200px;
    -moz-border-radius: 200px;
    border-radius: 200px;
    padding: 8px 40px;
    margin: 0 12px;
  }
  a:nth-child(1) {
    border: 1px solid #2d652e;
  }
  a:nth-child(2) {
    background: #00d8a0;
    color: #fff;
  }
}
</style>
